import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CoreRoutingModule } from './core-routing.module';
import { SharedModule } from '../shared.module';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { NavigationBarComponent } from './components/navigation-bar/navigation-bar.component';
import { NavigationMenuComponent } from './components/navigation-menu/navigation-menu.component';
import { NavigationMenuService } from './components/navigation-menu/navigation-menu.service';

@NgModule({
  declarations: [LoginComponent, HomeComponent, NavigationMenuComponent, NavigationBarComponent],
  imports: [CoreRoutingModule, HttpClientModule, SharedModule],
  exports: [LoginComponent, HomeComponent, NavigationMenuComponent, NavigationBarComponent],
})
export class CoreModule {
  static forRoot(menu: string): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [NavigationMenuService, { provide: 'menu', useValue: menu }],
    };
  }
}
